/*
  Sole Store collection filters (sections/tss-collection.liquid).
  Filters live in the URL: ?size=9,9.5&colour=black&brand=jordan&type=trainers
  &model=jordan-4&price=100-150&sort=best. Every product is already in the page,
  so filtering, counting and sorting happen in place with no extra requests.
*/
(function () {
  'use strict';

  var SWATCH = {
    black: '#0b0b0b', white: '#ffffff', grey: '#9a9a96', silver: '#c9c9c7', cream: '#ece6d6',
    beige: '#cbbfa6', green: '#5d7a52', blue: '#5b7fa6', pink: '#e8b8c2', brown: '#7a5a41',
    red: '#b3261e', orange: '#e07b39', yellow: '#e8c547', purple: '#7b5ea7', multi: 'conic-gradient(#b3261e,#e8c547,#5d7a52,#5b7fa6,#b3261e)'
  };
  var CLOTHING_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
  var PRICE_BANDS = [
    { key: '-50', label: 'Under £50', min: 0, max: 5000 },
    { key: '50-100', label: '£50 to £100', min: 5000, max: 10000 },
    { key: '100-150', label: '£100 to £150', min: 10000, max: 15000 },
    { key: '150-200', label: '£150 to £200', min: 15000, max: 20000 },
    { key: '200-', label: '£200 and over', min: 20000, max: Infinity }
  ];
  var GROUPS = [
    { key: 'size', label: 'Size', grid: true },
    { key: 'colour', label: 'Colour' },
    { key: 'brand', label: 'Brand' },
    { key: 'type', label: 'Type' },
    { key: 'model', label: 'Model' },
    { key: 'price', label: 'Price' }
  ];

  function init(root) {
    var grid = root.querySelector('[data-tcg-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.tcg__item'));
    var pageSize = parseInt(root.dataset.pageSize, 10) || 24;
    var shown = pageSize;
    var bestList = [];
    try { bestList = JSON.parse(root.querySelector('[data-tcg-best-list]').textContent); } catch (e) {}
    var bestRank = {};
    bestList.forEach(function (h, i) { bestRank[h] = i; });

    var data = items.map(function (el) {
      var split = function (s) { return (s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
      var d = {
        el: el,
        handle: el.dataset.handle,
        size: split(el.dataset.sizes),
        colour: split(el.dataset.colours),
        brand: el.dataset.brand ? [el.dataset.brand] : [],
        type: el.dataset.type ? [el.dataset.type] : [],
        model: el.dataset.model ? [el.dataset.model] : [],
        price: parseInt(el.dataset.price, 10) || 0,
        created: parseInt(el.dataset.created, 10) || 0,
        available: el.dataset.available === 'true',
        index: parseInt(el.dataset.index, 10) || 0,
        labels: { brand: el.dataset.brandLabel, type: el.dataset.typeLabel, model: el.dataset.modelLabel }
      };
      d.priceBand = PRICE_BANDS.filter(function (b) { return d.price >= b.min && d.price < b.max; }).map(function (b) { return b.key; });
      if (bestRank[d.handle] !== undefined && bestRank[d.handle] < 12 && d.available) {
        var badge = el.querySelector('[data-tcg-best]');
        if (badge) badge.hidden = false;
      }
      return d;
    });

    var labels = { brand: {}, type: {}, model: {}, colour: {}, size: {} };
    data.forEach(function (d) {
      ['brand', 'type', 'model'].forEach(function (k) { if (d[k][0]) labels[k][d[k][0]] = d.labels[k]; });
      d.colour.forEach(function (c) { labels.colour[c] = c.charAt(0).toUpperCase() + c.slice(1); });
      d.size.forEach(function (s) { labels.size[s] = /^\d/.test(s) ? 'UK ' + s : s.toUpperCase(); });
    });

    var state = readUrl();

    function readUrl() {
      var p = new URLSearchParams(location.search);
      var s = { sort: p.get('sort') || root.dataset.defaultSort || 'best' };
      GROUPS.forEach(function (g) {
        var v = p.get(g.key);
        s[g.key] = v ? v.toLowerCase().split(',').map(function (x) { return x.trim().replace(/^uk\s*/, ''); }).filter(Boolean) : [];
      });
      if (s.price.length) {
        s.price = s.price.map(function (v) {
          var m = PRICE_BANDS.filter(function (b) { return b.key === v; });
          if (m.length) return v;
          var parts = v.split('-');
          var lo = parts[0] ? parseFloat(parts[0]) * 100 : 0;
          var hi = parts[1] ? parseFloat(parts[1]) * 100 : Infinity;
          var hit = PRICE_BANDS.filter(function (b) { return b.min >= lo && b.max <= hi; }).map(function (b) { return b.key; });
          return hit;
        }).reduce(function (a, b) { return a.concat(b); }, []);
      }
      return s;
    }

    function writeUrl() {
      var p = new URLSearchParams(location.search);
      GROUPS.forEach(function (g) {
        if (state[g.key].length) p.set(g.key, state[g.key].join(','));
        else p.delete(g.key);
      });
      if (state.sort && state.sort !== root.dataset.defaultSort) p.set('sort', state.sort);
      else p.delete('sort');
      p.delete('page');
      var q = p.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }

    function matches(d, skip) {
      if (state.size.length && skip !== 'size' && !state.size.some(function (v) { return d.size.indexOf(v) > -1; })) return false;
      if (state.colour.length && skip !== 'colour' && !state.colour.some(function (v) { return d.colour.indexOf(v) > -1; })) return false;
      if (state.brand.length && skip !== 'brand' && state.brand.indexOf(d.brand[0]) < 0) return false;
      if (state.type.length && skip !== 'type' && state.type.indexOf(d.type[0]) < 0) return false;
      if (state.model.length && skip !== 'model' && state.model.indexOf(d.model[0]) < 0) return false;
      if (state.price.length && skip !== 'price' && !state.price.some(function (v) { return d.priceBand.indexOf(v) > -1; })) return false;
      return true;
    }

    function sortKey(a, b) {
      if (a.available !== b.available) return a.available ? -1 : 1;
      switch (state.sort) {
        case 'new': return b.created - a.created || a.index - b.index;
        case 'low': return a.price - b.price;
        case 'high': return b.price - a.price;
        default:
          var ra = bestRank[a.handle] !== undefined ? bestRank[a.handle] : 9999;
          var rb = bestRank[b.handle] !== undefined ? bestRank[b.handle] : 9999;
          return ra - rb || a.index - b.index;
      }
    }

    function sizeOrder(a, b) {
      var na = parseFloat(a), nb = parseFloat(b);
      if (!isNaN(na) && !isNaN(nb)) return na - nb;
      if (!isNaN(na)) return -1;
      if (!isNaN(nb)) return 1;
      return CLOTHING_ORDER.indexOf(a) - CLOTHING_ORDER.indexOf(b);
    }

    var groupsEl = root.querySelector('[data-tcg-groups]');
    function renderGroups() {
      var openKeys = Array.prototype.slice.call(groupsEl.querySelectorAll('details[open]')).map(function (d) { return d.dataset.key; });
      var html = '';
      GROUPS.forEach(function (g) {
        var counts = {};
        data.forEach(function (d) {
          if (!matches(d, g.key)) return;
          var vals = g.key === 'price' ? d.priceBand : d[g.key];
          vals.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
        });
        var values;
        if (g.key === 'price') values = PRICE_BANDS.map(function (b) { return b.key; });
        else {
          var all = {};
          data.forEach(function (d) { d[g.key].forEach(function (v) { all[v] = 1; }); });
          values = Object.keys(all);
          if (g.key === 'size') values.sort(sizeOrder);
          else values.sort(function (a, b) { return (labels[g.key][a] || a).localeCompare(labels[g.key][b] || b); });
        }
        values = values.filter(function (v) { return counts[v] || state[g.key].indexOf(v) > -1; });
        if (values.length < 2 && !state[g.key].length) return;
        var open = state[g.key].length || openKeys.indexOf(g.key) > -1;
        html += '<details class="tcg__group" data-key="' + g.key + '"' + (open ? ' open' : '') + '><summary>' + g.label +
          (state[g.key].length ? ' (' + state[g.key].length + ')' : '') + '</summary><div class="tcg__group-body"><div class="tcg__opts' + (g.grid ? '' : ' tcg__opts--list') + '">';
        values.forEach(function (v) {
          var on = state[g.key].indexOf(v) > -1;
          var n = counts[v] || 0;
          var label = g.key === 'price' ? PRICE_BANDS.filter(function (b) { return b.key === v; })[0].label : (labels[g.key][v] || v);
          var sw = g.key === 'colour' && SWATCH[v] ? '<span class="tcg__sw" style="background:' + SWATCH[v] + '"></span>' : '';
          html += '<button type="button" class="tcg__opt" data-group="' + g.key + '" data-value="' + v + '" aria-pressed="' + on + '"' + (!n && !on ? ' disabled' : '') + '>' +
            (g.grid ? label : '<span style="display:flex;align-items:center;gap:8px">' + sw + label + '</span><span class="tcg__opt-n">' + n + '</span>') + '</button>';
        });
        html += '</div></div></details>';
      });
      groupsEl.innerHTML = html;
    }

    var chipsEl = root.querySelector('[data-tcg-chips]');
    function renderChips() {
      var html = '';
      var total = 0;
      GROUPS.forEach(function (g) {
        state[g.key].forEach(function (v) {
          total++;
          var label = g.key === 'price' ? (PRICE_BANDS.filter(function (b) { return b.key === v; })[0] || {}).label : (labels[g.key][v] || v);
          html += '<button type="button" class="tcg__chip" data-group="' + g.key + '" data-value="' + v + '" aria-label="Remove ' + label + '">' + label + '</button>';
        });
      });
      if (total > 1) html += '<button type="button" class="tcg__chip tcg__chip--clear" data-tcg-clear>Clear all</button>';
      chipsEl.innerHTML = html;
      chipsEl.hidden = total === 0;
      var badge = root.querySelector('[data-tcg-active-count]');
      badge.textContent = total;
      badge.hidden = total === 0;
    }

    function apply(resetPaging) {
      if (resetPaging) shown = pageSize;
      var visible = data.filter(function (d) { return matches(d); }).sort(sortKey);
      var visibleSet = new Set(visible);
      visible.forEach(function (d, i) {
        grid.appendChild(d.el);
        d.el.hidden = i >= shown;
      });
      data.forEach(function (d) { if (!visibleSet.has(d)) d.el.hidden = true; });
      var n = visible.length;
      var sizeNote = state.size.length === 1 ? ' in ' + labels.size[state.size[0]] : '';
      root.querySelector('[data-tcg-count]').textContent = n + (n === 1 ? ' style' : ' styles') + sizeNote;
      root.querySelector('[data-tcg-apply-count]').textContent = n;
      root.querySelector('[data-tcg-empty]').hidden = n > 0;
      root.querySelector('[data-tcg-more]').hidden = n <= shown;
      root.querySelector('[data-tcg-sort]').value = state.sort;
      renderGroups();
      renderChips();
    }

    function toggle(group, value) {
      var list = state[group];
      var i = list.indexOf(value);
      if (i > -1) list.splice(i, 1); else list.push(value);
      writeUrl();
      apply(true);
    }

    function clearAll() {
      GROUPS.forEach(function (g) { state[g.key] = []; });
      writeUrl();
      apply(true);
    }

    var openBtn = root.querySelector('[data-tcg-open]');
    var scrim = root.querySelector('.tcg__scrim');
    function setOpen(open) {
      root.classList.toggle('is-open', open);
      scrim.hidden = !open;
      openBtn.setAttribute('aria-expanded', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) {
        var first = root.querySelector('.tcg__drawer button');
        if (first) first.focus();
      } else {
        openBtn.focus();
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.tcg__opt, .tcg__chip[data-group]');
      if (opt) { toggle(opt.dataset.group, opt.dataset.value); return; }
      if (e.target.closest('[data-tcg-clear]')) { clearAll(); return; }
      if (e.target.closest('[data-tcg-open]')) { setOpen(true); return; }
      if (e.target.closest('[data-tcg-close]')) { setOpen(false); return; }
      if (e.target.closest('[data-tcg-more]')) { shown += pageSize; apply(false); }
    });
    root.querySelector('[data-tcg-sort]').addEventListener('change', function (e) {
      state.sort = e.target.value;
      writeUrl();
      apply(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
    });

    apply(true);
  }

  function boot() {
    document.querySelectorAll('[data-tcg]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
